import React from "react";

class Impressum extends React.Component {

  componentDidMount() {

  }

  render() {
    return (
      <div key='impressum' class='contentcontainer'>
        <div class='contentheader'>Impressum</div>
        <div class='content-thin' >
          <b>Augenstern e.K.</b><br /><br /><br />
          <b>Inhaberin:</b><br />
          Alexandra Gabriele Faltermeier<br />
          HRA 6794<br />
          USt.-IdNr. 216 / 20856<br /><br />
          Inhaltlich Verantwortliche gemäß § 6 MDSTV:<br /><br />
          Bocksberg 9<br />
          94368 Perkam<br />
          Deutschland<br /><br />
          Telefon: + 49 (0) 151 111 988 97<br />
          E-Mail: info@augenstern-schmuck.de<br />
          Homepage: www.augenstern-schmuck.de<br /><br />
          SITZ: STRAUBING, LANDKREIS STRAUBING<br />
          <br /><br />
        </div>
      </div >
    );
  }
}

export default (Impressum);
